import { useCallback } from "react";
import { message } from "antd";

import PlanReviewReadOnlyNotice from "components/plan-review-read-only-notice/plan-review-read-only-notice";

import { useLoggedUser } from "state/reactive-vars/logged-user-var";
import { UserRoleValue } from "constants/field-values";
import { PLAN_REVIEW_SETTINGS_READ_ONLY_MESSAGE } from "constants/constants";

// Mirrors the insert, update and delete permissions on plan_review_requirements,
// plan_review_submission_types and plan_review_categories, and on the two extraction
// actions: AHJ staff read them, their manager changes them.
const MANAGING_ROLES = [UserRoleValue.admin_user, UserRoleValue.authority_manager];

/**
 * Who may change the AHJ's rules, submission types and review categories.
 *
 * Everyone in the organization reads these screens; only a manager writes to them.
 * Hasura already rejects the write, but it reaches the reader as a server error that
 * names nothing they can act on — so the attempt is answered here instead.
 */
export const usePlanReviewSettingsAccess = () => {
	const { loggedUserValue } = useLoggedUser();
	const canManage = MANAGING_ROLES.includes(loggedUserValue?.role as UserRoleValue);

	// Called by every create, update and delete entry point, in place of opening a form
	// whose save could only fail.
	const blockChange = useCallback(() => {
		message.info(PLAN_REVIEW_SETTINGS_READ_ONLY_MESSAGE);
	}, []);

	// Rendered by the screen above its table; null for a manager.
	const notice = canManage ? null : <PlanReviewReadOnlyNotice />;

	return { canManage, blockChange, notice };
};
